import {Controller} from "@hotwired/stimulus";
import GtagService from "../../../services/GtagService";

export default class extends Controller {

    connect() {
      document.addEventListener("DOMContentLoaded", function() {
        let errorDiv = document.querySelector("[data-seconds]");
        if (errorDiv) {
          let secondsBlock = errorDiv.querySelector("span");
          let secondsInt = errorDiv.getAttribute("data-seconds");
          let buttonLogin = document.querySelector(".register-card-left-btn");
          buttonLogin.disabled = true
          buttonLogin.classList.remove('text-white')
          let updateTime = setInterval(() => {
            secondsInt = secondsInt - 1;
            if (secondsInt < 1) {
              errorDiv.classList.add("d-none");
              buttonLogin.disabled = false;
              buttonLogin.classList.add('text-white')
            }
            secondsBlock.innerHTML = secondsInt;
          }, 1000);

          setTimeout(() => {
            clearInterval(updateTime);
          }, 60000);
        }

      }, false);
    }
  get isMeLink() {
    return this.element.dataset.meLink === '1';
  }

  get successEvent() {
    return this.element.dataset.successEvent;
  }

  gtagLoginClick() {
    if (this.isMeLink) {
      return;
    }
    const event = this.element.dataset.event;
    const locale = window.location.pathname.split("/")[1].toUpperCase()
    gtag("event", event, {
      method: "mail",
      site_language: locale.length > 2 ? "EN" : locale,
    });
  }
  gtagGoogleClick(stimulusEvent) {
    if (this.isMeLink) {
      const targetUrl = stimulusEvent.target.closest("a")?.href;
      if (targetUrl) {
        stimulusEvent.preventDefault();
        GtagService.gtagEventAndNavigate({ event: this.successEvent, targetUrl });
        return;
      }
      gtag("event", this.successEvent);
      return;
    }
    const event = this.element.dataset.event;
    const locale = window.location.pathname.split("/")[1].toUpperCase()
    gtag("event", event, {
      method: "gmail",
      site_language: locale.length > 2 ? "EN" : locale,
    });
  }


  togglePasswordVisibility(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const input = button.closest(".form-floating")?.querySelector('input[name="password"], input[name="registration_form[plainPassword]"]');
    if (!input) {
      return;
    }

    const visible = input.type === "password";
    input.type = visible ? "text" : "password";
    const icons = button.querySelectorAll("svg");
    icons[0]?.classList.toggle("d-none", visible);
    icons[1]?.classList.toggle("d-none", !visible);
  }

  handleLoginSubmit() {
    try {
      if (this.isMeLink) {
        if (typeof gtag === "function") {
          gtag("event", this.successEvent, { transport_type: "beacon" });
        }
      } else {
        this.gtagLoginClick();
      }
    } catch (e) {
    }
  }
}
